import type { SearchContext } from '@shared/types/types';

/**
 *
 *
 */
const ASSORTMENTS_WITH_TOP_INFO = [
    'Haushaltsgeräte',
    'Unterhaltungselektronik',
    'Optik',
    'Kommunikation',
    'Reinigungsgeräte',
    'Klima',
    'Bürotechnik',
    'Fahrzeuge',
    'Gartengeräte',
    'Heizen',
    'Sportausrüstung',
    'Zahnpflege',
    'Elektroinstallation',
] as const;

const ASSORTMENTS_WITH_MULTIPLE_SIZES = ['Möbel'] as const;

const ASSORTMENTS_SET = new Set(ASSORTMENTS_WITH_TOP_INFO.map((item) => item.toLowerCase()));
const MULTIPLE_SIZES_ASSORTMENTS_SET = new Set(ASSORTMENTS_WITH_MULTIPLE_SIZES.map((item) => item.toLowerCase()));

function normalizeAssortment(searchContext: SearchContext | undefined): string | undefined {
    const assortment = searchContext?.assortment;
    return assortment ? assortment.toLowerCase() : undefined;
}

export function shouldShowMultipleSizes(searchContext?: SearchContext): boolean {
    const normalized = normalizeAssortment(searchContext);
    if (!normalized) return false;

    return MULTIPLE_SIZES_ASSORTMENTS_SET.has(normalized);
}

export function shouldShowTopInfos(searchContext?: SearchContext): boolean {
    const normalized = normalizeAssortment(searchContext);
    if (!normalized) return false;

    return ASSORTMENTS_SET.has(normalized) || MULTIPLE_SIZES_ASSORTMENTS_SET.has(normalized);
}
